export default __webpack_public_path__ + "static/media/torso-top-right-side.c973ff18.png";